<template>
    <div class="card">
        <div class="card-header">
            <div class="d-flex align-items-center">
                <div class="m-r-10">
                    <span class="display-5">
                        <img src="../../../../assets/images/audits/rspo.png" style="width: 150px;">
                    </span>
                </div>
                <div class="m-r-40">
                    <div><h4>RSPO Audit Report</h4></div>
                    <template v-if="auditReport.audited_by">
                        <div>{{auditReport.audited_by.firm.name}}</div>
                        <span class="text-muted">Auditor</span>
                    </template>
                    <div>
                        <a v-if="auditReport.borlaug" target="_blank" v-bind:href="this.$BORLAUG + '/address/' + auditReport.borlaug.address">{{auditReport.borlaug.address}}</a>
                    </div>
                    <span class="text-muted">Contract Address</span>
                </div>
            </div>
        </div>
        <hr/>
        <div class="card-body">
            <div class="row">
                <div class="col-12">
                    <v-chart :options="options" auto-resize ref="map"/>
                </div>
            </div>
            <div class="row m-t-40">
                <div class="col-4">
                    <div class="row">
                        <div class="col-lg-12 m-t-40 m-l-10" v-if="auditReport.summary && auditReport.summary.consolidated">
                            <div class="d-flex align-items-center">
                                <div class="icon">
                                    <span class="display-6">
                                        <i class="fas fa-globe"></i>
                                    </span>
                                </div>
                                <div>
                                    <h3 class="font-medium m-b-0">{{auditReport.summary.consolidated.yesCount}} / {{auditReport.summary.consolidated.totalCount}}</h3>
                                    <span>Complies / Total</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-8">
                    <div class="row">
                        <div class="col-lg-6 m-b-25" v-if="auditReport.summary && auditReport.summary.prosperity && auditReport.summary.prosperity.totalCount > 0">
                            <div class="d-flex align-items-center">
                                <div class="icon m-r-10">
                                    <span class="display-6">
                                        <i class="fas fa-hand-holding-usd"></i>
                                    </span>
                                </div>
                                <div>
                                    <h3 class="font-medium m-b-0">{{ auditReport.summary.prosperity.yesCount * 100 / (auditReport.summary.prosperity.totalCount===0?1:auditReport.summary.prosperity.totalCount) | percentage(2)}}</h3>
                                    <span>Prosperity</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 m-b-25" v-if="auditReport.summary && auditReport.summary.people && auditReport.summary.people.totalCount > 0">
                            <div class="d-flex align-items-center">
                                <div class="icon m-r-10">
                                    <span class="display-6">
                                        <i class="fas fa-users"></i>
                                    </span>
                                </div>
                                <div>
                                    <h3 class="font-medium m-b-0">{{ auditReport.summary.people.yesCount * 100 / (auditReport.summary.people.totalCount===0?1:auditReport.summary.people.totalCount) | percentage(2)}}</h3>
                                    <span>People</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 m-b-25" v-if="auditReport.summary && auditReport.summary.planet && auditReport.summary.planet.totalCount > 0">
                            <div class="d-flex align-items-center">
                                <div class="icon m-r-10">
                                    <span class="display-6">
                                        <i class="fas fa-globe-americas"></i>
                                    </span>
                                </div>
                                <div>
                                    <h3 class="font-medium m-b-0">{{ auditReport.summary.planet.yesCount * 100 / (auditReport.summary.planet.totalCount===0?1:auditReport.summary.planet.totalCount) | percentage(2)}}</h3>
                                    <span>Planet</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 m-b-25" v-if="auditReport.summary && auditReport.summary.custom  && auditReport.summary.custom.totalCount > 0">
                            <div class="d-flex align-items-center">
                                <div class="icon m-r-10">
                                    <span class="display-6">
                                        <i class="fab fa-whmcs"></i>
                                    </span>
                                </div>
                                <div>
                                    <h3 class="font-medium m-b-0">
                                        {{ auditReport.summary.custom.yesCount * 100 / (auditReport.summary.custom.totalCount===0?1:auditReport.summary.custom.totalCount) | percentage(2)}}</h3>
                                    <span>Custom</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer text-muted">
            Audits provided by <a href="https://www.truvito.io" target="_blank">TruVito<sup>&trade;</sup></a>
        </div>
    </div>
</template>

<script>
    import ECharts from 'vue-echarts/components/ECharts';
    import 'echarts/lib/chart/pie';
    import 'echarts/lib/component/legend';
    import 'echarts/lib/component/tooltip';
    import 'echarts/lib/component/title';

    export default {
        name: "RSPOReport",
        props: ["audit"],
        components: {
            'v-chart': ECharts
        },
        watch: {
            audit: function(newVal, oldVal) {
                if(this.audit.id) {
                    this.getAuditReport();
                }
            }
        },
        data() {
            return {
                options: {
                    title: {
                        text: 'RSPO Audit Summary',
                        x: 'left',
                    },
                    tooltip: {
                        trigger: 'item',
                        formatter: "{a} <br/>{b}: {c} ({d}%)"
                    },
                    legend: {
                        orient: 'vertical',
                        x: 'left',
                        data: [],
                        top: '50px',
                    },
                    series: [
                        {
                            name: 'Audit',
                            type: 'pie',
                            label: {
                                normal: {
                                    position: 'center',
                                    color: '#fff'
                                }
                            },
                            radius: [0, '20%'],
                            center: ['60%', '60%'],
                            data: []
                        },
                        {
                            name: 'Module',
                            type: 'pie',
                            label: {
                                normal: {
                                    position: 'inner'
                                }
                            },
                            radius: ['35%', '60%'],
                            center: ['60%', '60%'],
                            data: []
                        },
                        {
                            name: 'Compliance',
                            type: 'pie',
                            radius: ['70%', '80%'],
                            center: ['60%', '60%'],
                            data: []
                        }
                    ]
                },
                auditReport: {
                    audited_by: {
                        auditor: {
                            address: null,
                            biz_address: null
                        },
                        firm: {
                            address: null,
                            biz_address: null
                        }
                    },
                    borlaug: {
                        address: null,
                        tx: null
                    },
                    coop: {
                        address: null,
                        biz_address: null,
                        org_props: null
                    },
                    created_by: {
                        address: null
                    },
                    id: null,
                    created_on: null,
                    report: null,
                    status: null,
                    title: null,
                    type: null,
                    summary: null
                }
            }
        },
        mounted() {
            this.getAuditReport();
        },
        methods: {
            async getAuditReport() {
                let reply        = await this.$http.get(`/integrations/audits/${this.audit.id}`);
                this.auditReport = reply.data;
                this.setChartData(this.auditReport.summary);

            },
            setChartData(summary) {
                let data         = ['RSPO'];
                let parentData   = [{value: summary.consolidated.totalCount, name: 'RSPO'}];
                let childData    = [];
                let subChildData = [];
                if(summary.prosperity && summary.prosperity.totalCount > 0) {
                    data.push('Prosperity');
                    childData.push({value: summary.prosperity.totalCount, name: 'Prosperity'});
                    subChildData.push({value: summary.prosperity.yesCount, name: 'Prosperity Yes'});
                    subChildData.push({value: summary.prosperity.noCount, name: 'Prosperity No'});
                    subChildData.push({value: summary.prosperity.naCount, name: 'Prosperity N/A'});
                    subChildData.push({value: summary.prosperity.totalCount - (summary.prosperity.yesCount + summary.prosperity.noCount + summary.prosperity.naCount), name: 'Prosperity Unknown'});
                }
                if(summary.people && summary.people.totalCount > 0) {
                    data.push('People');
                    childData.push({value: summary.people.totalCount, name: 'People'});
                    subChildData.push({value: summary.people.yesCount, name: 'People Yes'});
                    subChildData.push({value: summary.people.noCount, name: 'People No'});
                    subChildData.push({value: summary.people.naCount, name: 'People N/A'});
                    subChildData.push({value: summary.people.totalCount - (summary.people.yesCount + summary.people.noCount + summary.people.naCount), name: 'People Unknown'});
                }
                if(summary.planet && summary.planet.totalCount > 0) {
                    data.push('Planet');
                    childData.push({value: summary.planet.totalCount, name: 'Planet'});
                    subChildData.push({value: summary.planet.yesCount, name: 'Planet Yes'});
                    subChildData.push({value: summary.planet.noCount, name: 'Planet No'});
                    subChildData.push({value: summary.planet.naCount, name: 'Planet N/A'});
                    subChildData.push({value: summary.planet.totalCount - (summary.planet.yesCount + summary.planet.noCount + summary.planet.naCount), name: 'Planet Unknown'});
                }
                if(summary.custom && summary.custom.totalCount > 0) {
                    data.push('Custom');
                    childData.push({value: summary.custom.totalCount, name: 'Custom'});
                    subChildData.push({value: summary.custom.yesCount, name: 'Custom Yes'});
                    subChildData.push({value: summary.custom.noCount, name: 'Custom No'});
                    subChildData.push({value: summary.custom.naCount, name: 'Custom N/A'});
                    subChildData.push({value: summary.custom.totalCount - (summary.custom.yesCount + summary.custom.noCount + summary.custom.naCount), name: 'Custom Unknown'});
                }

                this.options.legend.data    = data;
                this.options.series[0].data = parentData;
                this.options.series[1].data = childData;
                this.options.series[2].data = subChildData;

                this.options = JSON.parse(JSON.stringify(this.options));
            }
        }
    }
</script>

<style scoped>
    .echarts {
        width: 100%;
        height: 400px;
    }

    .icon {
        min-width: 60px;
    }
</style>
